import { useWebAppContext } from 'app/src/shared/hooks'
import { Toast } from 'primereact/toast'

export function ToastMessages() {
  const context = useWebAppContext()

  return (
    <div className='card justify-content-center flex'>
      <Toast ref={context.toastMessagesRef} />
    </div>
  )
}
